import { Product, Price, OfferContractSpan } from '@eneco/flows/types';
import {
  DC_Domain_Models_Products_DiscountType,
  Products_Offers_V3_OfferProductResponseModel,
  Products_Offers_V3_OfferResponseModel,
  Products_Offers_ProductCostDetail,
  Products_Offers_V3_OfferProductCombinationResponseModel,
} from '@monorepo-types/dc';

export const getOfferContractSpanFromProducts = (products: Product[]): OfferContractSpan[] =>
  products.map(product => {
    if (product.contractSpan) {
      return {
        ...product.contractSpan,
        type: product.type === 'warmthEkv' ? 'warmth' : product.type,
      };
    }

    return {
      duration: 0,
      byPeriod: 'D',
      type: 'unknown',
    };
  });

export const selectOfferByOfferType = (
  offer: Products_Offers_V3_OfferResponseModel,
  offerType: DC_Domain_Models_Products_DiscountType,
): Products_Offers_V3_OfferProductResponseModel | undefined => {
  if (!offer.products) {
    return undefined;
  }

  return offer.products.find(product => product.productType === offerType) ?? offer.products[0];
};

export const getCashbackValue = (
  selectedProductCombination: Products_Offers_V3_OfferProductCombinationResponseModel,
  offer?: Products_Offers_V3_OfferResponseModel,
): Price | undefined => {
  const cashbackProductCode = selectedProductCombination.products?.find(
    p => p.productType === 'cashback',
  )?.marketingProductCode;

  if (!cashbackProductCode || !offer?.products) {
    return undefined;
  }

  const cashbackProduct = offer.products.find(p => p.internalDcMarketingProductCode === cashbackProductCode);

  if (!cashbackProduct) {
    return undefined;
  }

  const cashbackProductCostDetails = cashbackProduct.costDetails?.find(
    c => c.type === 'cashBackDirect' || c.type === 'cashBackOnYearNote',
  );

  if (!cashbackProductCostDetails) {
    return undefined;
  }

  return {
    value: Number(cashbackProductCostDetails.value),
    type: cashbackProductCostDetails.type ?? 'unKnown',
  };
};

export const selectCostDetailsByType = (type: string, costs?: Products_Offers_ProductCostDetail[] | null) => {
  return costs?.find(cost => cost.type === type)?.costs;
};
